(function () {
    'use strict';

    angular
        .module('salesflare.components.workflowUtils.exitWorkflowRecordButton', [])
        .component('sfExitWorkflowRecordButton', {
            controller,
            controllerAs: 'vm',
            templateUrl: 'app-ajs/components/workflows/workflow/exitWorkflowRecordButton/exitWorkflowRecordButton.html',
            bindings: {
                recordId: '<',
                exitDate: '<',
                workflowId: '<',
                recordType: '<',
                showCompact: '<',
                onExit: '<',
                onReEnter: '<'
            }
        });

    function controller($mdDialog, $mdMenu, utils, workflowService, $translate) {

        const vm = this;

        vm.recordTypeNameMap = {
            contact: {
                lowerCased: $translate.instant('contact'),
                properCased: $translate.instant('Contact')
            }
        };
        vm.buttonTypes = {
            EXIT: 'EXIT',
            ENTER: 'ENTER'
        };

        vm.$onInit = () => {

            vm.recordType = vm.recordType || 'contact';
        };

        vm.getTooltipText = (buttonType) => {

            switch (buttonType) {
                case vm.buttonTypes.EXIT:
                    if (vm.exitDate) {
                        return $translate.instant('{{recordType}} has already exited the workflow.', { recordType: vm.recordTypeNameMap[vm.recordType].properCased });
                    }
                    else {
                        return $translate.instant('Exit {{recordType}} manually. No future workflow steps will happen for this contact (no emails will be sent).', { recordType: vm.recordTypeNameMap[vm.recordType].lowerCased });
                    }

                case vm.buttonTypes.ENTER:
                    return $translate.instant('Re-enter the {{recordType}} in the workflow. Future workflow steps will be sent.', { recordType: vm.recordTypeNameMap[vm.recordType].properCased });
                default:
                    throw new Error('Invalid button type');
            }
        };

        vm.getExitMeetingGoalText = () => {
            return $translate.instant('Exit {{recordType}} meeting goal', { recordType: vm.recordTypeNameMap[vm.recordType].lowerCased });
        };

        vm.getExitWithoutMeetingGoalText = () => {
            return $translate.instant('Exit {{recordType}} without meeting goal', { recordType: vm.recordTypeNameMap[vm.recordType].lowerCased });
        };

        vm.reEnterRecordText = () => {
            return $translate.instant('Re-enter {{recordType}}', { recordType: vm.recordTypeNameMap[vm.recordType].lowerCased });
        };

        vm.contactCannotReEnterTranslation = (params) => {
            return $translate.instant('This contact can not be re-entered, as it hasn\'t moved steps in {{movedInDays}} days, which is more than the {{afterDays}} days specified in the workflow\'s settings. Change this first before trying again.', { movedInDays: params.movedInDays, afterDays: params.afterDays });
        };

        vm.exitRecord = (metGoal) => {

            const update = {
                exited: true
            };

            if (metGoal) {
                update.met_goal = true;
            }

            return workflowService.updateWorkflowRecord(vm.workflowId, vm.recordId, update).then(() => {

                vm.exitDate = new Date();

                if (vm.onExit) {
                    vm.onExit({
                        workflowId: vm.workflowId,
                        recordId: vm.recordId,
                        exitDate: new Date(),
                        metGoalDate: metGoal ? new Date() : null
                    });
                }

                return utils.showSuccessToast($translate.instant('{{recordType}} has been exited', { recordType: vm.recordTypeNameMap[vm.recordType].properCased }));
            });
        };

        vm.reEnterRecord = () => {

            const update = {
                exited: false
            };
            const apiOptions = {
                noToast: true,
                noToastForStatusCode: [422]
            };

            return workflowService.updateWorkflowRecord(vm.workflowId, vm.recordId, update, apiOptions).then(function () {

                vm.exitDate = null;

                if (vm.onReEnter) {
                    vm.onReEnter({
                        workflowId: vm.workflowId,
                        recordId: vm.recordId,
                        exitDate: null,
                        metGoalDate: null
                    });
                }

                return utils.showSuccessToast($translate.instant('{{recordType}} has been re-entered', { recordType: vm.recordTypeNameMap[vm.recordType].properCased }));
            }).catch((err) => {

                if (err.status === 422 && err.data.message.includes('can not be re-entered')) {
                    const regex = /^\s*This contact can not be re-entered, as it hasn't moved steps in\s+(.+?)\s+days, which is more than the\s+(.+?)\s+days specified in the workflow's settings. Change this first before trying again.\s*$/;
                    const errMatch = err.data.message.match(regex);
                    const message = errMatch?.length ? vm.contactCannotReEnterTranslation({ movedInDays: errMatch[1], afterDays: errMatch[2] }) : err.data.message;

                    const confirm = $mdDialog.confirm({ multiple: true })
                        .clickOutsideToClose(true)
                        .title($translate.instant('Change workflow setting first'))
                        .htmlContent(message)
                        .ok($translate.instant('Got it'));
                    return $mdDialog.show(confirm);
                }
            });
        };
    }
})();
